import { useCallback, useEffect, useState, useRef } from "react";

export default function useAnimationFrameUpdater({ updateRate = 1 }) {
  const setUpdate = useState(1)[1];
  const frameRequestIdRef = useRef(null);
  const counterRef = useRef(0);

  const updateSelf = useCallback(() => {
    counterRef.current++;
    if (counterRef.current % updateRate === 0) {
      setUpdate((current) => current * -1);
    }
    frameRequestIdRef.current = requestAnimationFrame(() => updateSelf());
  }, [frameRequestIdRef, updateRate, setUpdate]);

  useEffect(() => {
    updateSelf();
    return () => cancelAnimationFrame(frameRequestIdRef.current);
  }, [frameRequestIdRef, updateSelf]);
}
